<template>
  <div class="m-k__row m-k__row_model">
    <div @click="toggle" class="m-k__c m-k__c_first" data-toogle-markup=".m-k__model">
      {{ model.name }}
      <span class="m-k__model-title_additional">({{ model.additional }})</span>
      <div class="m-k__modifiers-list">
        <span v-for="modifier in model.viewModifiers"
              :class="['m-k__modifier-dot', `m-k__modifier-dot_${modifier}`]"
        >
        </span>
      </div>

      <TheSearchPanel :query="model.name"/>
    </div>

    <!--Rows-->
    <div v-for="column in this.data.columns.filter(c => !c.disable)"
         :class="['m-k__c', getColumnClasses(column)]"
    >
      <div class="m-k__w">
        <span class="m-k__perc">
            {{ getPercent(column, model, this.data.percents) }}%
        </span>

        <form class="m-k__markup-form" data-mark-form autocomplete="off"
              :data-marketplace="column.marketplaceKey"
              :data-seller="column.sellerId"
              :data-type="producer.type"
              :data-model-id="model.modelId"
        >
          <div class="m-k__inputs">
            <input type="number"
                   name="value"
                   step="0.01"
                   autocomplete="off"
                   placeholder="закуп"
                   :id="['_value_', getId(column, model)].join('')"
                   :value="getMarkup('incoming', column, model)"
                   @keyup.enter.prevent="submit($event)"
                   @keyup.shift.enter.prevent="rowSubmit($event)"
                   @keyup.shift.delete.prevent="rowClear($event)"
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "pinia";
import {useMarkupsStore} from "../../stores/markups";
import {markupsMixin} from "../../mixins/markupsMixin";
import TheSearchPanel from "./TheSearchPanel.vue";

export default {
  name: "TheModelLine",
  components: {TheSearchPanel},
  computed: {
    ...mapState(useMarkupsStore, [
      'data'
    ]),
  },
  props: ['model', 'producer'],
  mixins: [markupsMixin],
  methods: {
    getPercent(column, model, percents) {
      const key = this.getId(column, model);
      return percents[key] ? percents[key] : 0;
    },
    getId(column, model) {
      return ['m',column.marketplaceKey, column.sellerId, model.modelId].join('-');
    },
    getMarkup(type, column, model) {
      const key = this.getId(column, model);

      const getMarkupProperty = (markup) => {
        if (type === 'wholesale') return markup.percentWholesale;
        if (type === 'incoming') return markup.percent;
      };

      for (const markup of model.markups) {
        const markupKey = ['m', markup.marketplace, markup.seller, model.modelId].join('-');

        if (key === markupKey) {
          return getMarkupProperty(markup);
        }
      }

      return null;
    },
  }
}
</script>